import { Chat } from "../../classes"

const ChatModule = {
  namespaced: true,
  mutations: {
  },
  actions: {
    createChat: async ({ commit }, payload) => {
      const data = await Chat.createChat(payload);
      commit('appeal/setChatInAppeal', { appeal: data.appeal}, { root: true });
      return data;
    },
  },
  getters: {
    
  },
};
export default ChatModule;
